import { FC } from "react";
import { useTranslation } from "react-i18next";
import AccomplishedIconSVG from "../../../resources/svg/AccomplishedIconSVG";
import { NotificationType } from "../../../../domain/enums/NotificationTypeEnum";
import { NotificationDTO } from "../../../../domain/models/dto/NotificationDTO";
import { getNotificationCreatedTime } from "../../../../slices/notifications-slice";

interface ApplicationApprovedCardProps {
    notification: NotificationDTO;
    onClick: () => void;
}

const ApplicationApprovedCard: FC<ApplicationApprovedCardProps> = (props) => {
    const { t } = useTranslation();

    return (
        <div
            onClick={props.onClick}
            className="flex group cursor-pointer border-b border-b-textFaded pb-4 mb-3 dmax2:mb-2"
        >
            <div className="flex">
                <AccomplishedIconSVG className="min-w-8 min-h-8 text-textFaded group-hover:text-textWhite transition duration-300 mr-3" />
                <div className="flex flex-col">
                    <div className="flex gap-[30px] dmax2:gap-[10px]">
                        <p className="H20 dmax2:H14B text-textWhite">
                            {t(`notifications.${NotificationType.APPLICATION_APPROVED}`)}
                        </p>
                        <div className="H16 dmax2:H14 text-textFaded text-nowrap">
                            {getNotificationCreatedTime(t, props.notification, true)}
                        </div>
                    </div>
                    <p className="H16B dmax2:H14 text-textWarning mt-[10px] dmax2:mt-1 [word-break:break-word]">
                        {props.notification.application?.work.title}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ApplicationApprovedCard;
